var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreateTask = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 76,
  height: 64,
  style: {
    background: "#14202c"
  },
  viewBox: "0 0 76 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#69728B",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M7 2v14h14V2zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 24v14h14V24zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V24a2 2 0 0 1 2-2m0 24v14h14V46zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V46a2 2 0 0 1 2-2"
}), /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 2,
  x: 31,
  y: 8,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 2,
  x: 31,
  y: 30,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 2,
  x: 31,
  y: 52,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M13.531 12 10 9.406l1.149-1.402 2.134 1.566L16.589 6 18 7.166zm0 22L10 31.406l1.149-1.402 2.134 1.566L16.589 28 18 29.166zm0 22L10 53.406l1.149-1.402 2.134 1.566L16.589 50 18 51.166z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64 52h-3v-3a1 1 0 0 0-2 0v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 0 0 0-2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M60 62a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 2c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11"
}))));
export default SvgCreateTask;